export default {
  // 页面标题
  'orders.title': '订单管理',

  // 表格列
  'orders.table.orderId': '订单ID',
  'orders.table.shopifyNumber': 'Shopify编号',
  'orders.table.shopifyId': 'Shopify ID',
  'orders.table.dearId': 'DEAR ID',
  'orders.table.channel': '渠道',
  'orders.table.email': '邮箱',
  'orders.table.dearStatus': 'DEAR状态',
  'orders.table.fulfillmentStatus': '履行状态',
  'orders.table.createdAt': '创建时间',
  'orders.table.actions': '操作',

  // 状态标签
  'orders.status.success': '成功',
  'orders.status.failed': '失败',
  'orders.status.overall': '整体',
  'orders.status.sales': '销售',
  'orders.status.order': '订单',
  'orders.status.invoice': '发票',
  'orders.status.payment': '支付',
  'orders.status.fulfillment': '履行',
  'orders.status.pick': '拣货',
  'orders.status.pack': '包装',
  'orders.status.ship': '发货',

  // 状态提示
  'orders.tooltip.dearOverall': 'DEAR整体成功',
  'orders.tooltip.dearSales': 'DEAR销售成功',
  'orders.tooltip.dearOrder': 'DEAR订单成功',
  'orders.tooltip.dearInvoice': 'DEAR发票成功',
  'orders.tooltip.dearPayment': 'DEAR支付成功',
  'orders.tooltip.dearFulfillment': 'DEAR履行成功',
  'orders.tooltip.dearPick': 'DEAR拣货成功',
  'orders.tooltip.dearPack': 'DEAR包装成功',
  'orders.tooltip.dearShip': 'DEAR发货成功',
  'orders.tooltip.copyOrderNumber': '复制订单号',

  // 操作
  'orders.actions.pushToDear': '推送到DEAR',
  'orders.actions.fulfill': '履行订单',

  // 过滤器
  'orders.filter.shopifyId': '搜索 Shopify ID',
  'orders.filter.email': '搜索邮箱',
  'orders.filter.channel': '选择渠道',
  'orders.filter.startDate': '开始日期',
  'orders.filter.endDate': '结束日期',
  'orders.filter.reset': '重置',

  // 渠道
  'orders.channel.pointOfSale': 'Point of Sale',
  'orders.channel.onlineStore': 'Online Store',
  'orders.channel.facebook': 'Facebook',
  'orders.channel.instagram': 'Instagram',

  // 分页
  'orders.pagination.total': '第 {start}-{end} 条/共 {total} 条',

  // 消息提示
  'orders.message.getListFailed': '获取订单列表失败',
  'orders.message.pushSuccess': '订单推送成功',
  'orders.message.pushFailed': '推送失败',
  'orders.message.fulfillSuccess': '订单履行成功',
  'orders.message.fulfillFailed': '订单履行失败',
  'orders.message.copySuccess': '已复制订单号: {number}',
  'orders.message.copyFailed': '复制失败',
};